import * as React from 'react';
import classnames from 'classnames';
import { TooltipProvider } from './TooltipContext.js';
import { isTouchDevice } from '../../Util/is-touch-device.js';

const TooltipContainer = ({ className , theme , children ,  })=>{
    const [isActive, setIsActive] = React.useState(false);
    const isTouch = React.useMemo(isTouchDevice, []);
    const tooltipClass = classnames('tooltip', className, {
        'tooltip--black': theme === 'black',
        'tooltip--grey': theme === 'grey',
        'tooltip--white': theme === 'white'
    });
    return /*#__PURE__*/ React.createElement(TooltipProvider, {
        value: {
            isActive,
            setIsActive,
            isTouch
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: tooltipClass
    }, children));
};

export { TooltipContainer };
//# sourceMappingURL=TooltipContainer.js.map
